import { useState } from 'react';

import type { AIModelUseStep } from '@/lib/api/generated/model';
import type { IdentitySlot } from '../modelsLedger';
import { StepChip } from './StepChip';

/** How many of a workflow's steps show before "+N more" (spec 218 FR-004). */
const STEPS_SHOWN = 3;

/**
 * A workflow's steps on this profile (specs 218, 220): the first few, then a control
 * for the rest, each the one step chip the step map draws (spec 234), led by the
 * profile's dot. A published step opens the workflow on that step (R5); a step on
 * the profile only in unpublished changes is not in the published diagram, so it is
 * not a link, and it says so in words.
 */
export function StepChips({
  steps,
  workflowKey,
  workspaceId,
  slot,
  idle = false,
  profileName,
  profileKey,
}: {
  steps: AIModelUseStep[];
  workflowKey: string;
  workspaceId: string;
  slot: IdentitySlot;
  idle?: boolean;
  profileName: string;
  profileKey: string;
}) {
  const [expanded, setExpanded] = useState(false);
  const shown = expanded ? steps : steps.slice(0, STEPS_SHOWN);
  const hidden = steps.length - shown.length;
  return (
    <ul className="flex flex-wrap items-center gap-1.5">
      {shown.map((step) => (
        <li key={step.id} className="min-w-0">
          <StepChip
            kind="profile"
            name={step.name}
            slot={slot}
            idle={idle}
            profileName={profileName}
            profileKey={profileKey}
            unpublished={step.unpublished}
            link={{ workspaceId, workflowKey, stepId: step.id }}
          />
        </li>
      ))}
      {hidden > 0 && (
        <li>
          <button
            type="button"
            onClick={() => setExpanded(true)}
            className="touch-target text-muted-foreground hover:text-foreground focus-visible:ring-ring rounded-sm text-xs focus-visible:ring-3 focus-visible:outline-none"
          >
            {`+${String(hidden)} more`}
          </button>
        </li>
      )}
    </ul>
  );
}
